import { PushTopic } from "@seneca/notifications-service-types";

export const PushNotificationsSourceParamKey = "pushNotificationSource";
export const EmailNotificationsSourceParamKey = "emailNotificationSource";

export enum NotificationType {
  PUSH = "push",
  EMAIL = "email"
}

export enum NotificationStateKeys {
  SOURCE = "notificationSource",
  TYPE = "notificationType"
}

export type NotificationState = {
  source: PushTopic;
  type: NotificationType;
};
